var modules_8f2c8bee = {"container":"MaskInput_module_container__5134a1ff"};
import "../../../assets/esm/components/MaskInput/src/MaskInput~BTG5oZ4E.css";

export { modules_8f2c8bee as default };
//# sourceMappingURL=MaskInput.module.less.js.map
